import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import fetchEsim from '../../../../services/apollo/func/fetch/fetchEsim';
import handleReassignEsim from '../../../../services/apollo/func/handle/handleReassignEsim';

export const getSchema = () => {
  const schema = yup.object().shape({
    eID: yup.string().trim().required(''),
    currentAccount: yup.string().trim().required(''),
    newAccount: yup.string().trim().required(''),
  });
  return schema;
};

export const getForm = schema => useForm({
  mode: 'onChange',
  defaultValues: {
    eID: '',
    currentAccount: '',
    newAccount: '',
  },
  resolver: yupResolver(schema),
});

export const handleReaasignEID = async (esimId, newEmail) => {
  try {
    const input = {
      esimId,
      newEmail,
    };
    const reassignEID = await handleReassignEsim({ input });
    return reassignEID;
  } catch (err) {
    return {
      isSuccess: false,
      message: err.message,
    };
  }
};

export const handleFindEmailByEID = async (eID) => {
  const email = await fetchEsim({ esimId: eID }, 1);
  return email?.user?.email;
};
